import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TypeCalculatie } from '../dto/type-calculatie';
import { CrudService, Filter } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class TypeCalculatieService extends CrudService<TypeCalculatie> {

    constructor(injector: Injector) { super(TypeCalculatie, injector); }

    getOmschrijvingFilter(omschrijving: string): Filter<TypeCalculatie> {
        return new Filter<TypeCalculatie>(fb => [fb.equal("omschrijving", omschrijving)]);        
    }
}
